import { toast } from 'sonner';
import type { TSelectEvaluationSummary } from 'types/evaluation.types';
import { EEvaluationType, zMatrixSliderEvaluationWeighted } from 'types/evaluation.types';

export const updateSingleSelectEvaluationSummary = (evaluationSummary: TSelectEvaluationSummary) => {
  const x = {
    [EEvaluationType.Bonus]: 0,
    [EEvaluationType.Warning]: 0,
    [EEvaluationType.Disqualified]: 0,
    [EEvaluationType.Info]: 0,
    [EEvaluationType.AutoQualified]: 0,
  };

  for (const key in evaluationSummary.evaluation) {
    const value = evaluationSummary.evaluation[key];
    if (typeof value === 'object') {
      if (value.name === EEvaluationType.Info) {
        x[EEvaluationType.Info] += 1;
      } else if (value.name === EEvaluationType.Warning) {
        x[EEvaluationType.Warning] += 1;
      } else if (value.name === EEvaluationType.Bonus) {
        x[EEvaluationType.Bonus] = Math.max(x[EEvaluationType.Bonus], value.bonus_points ?? 0);
      } else if (value.name === EEvaluationType.Disqualified) {
        x[EEvaluationType.Disqualified] += 1;
      } else if (value.name === EEvaluationType.AutoQualified) {
        x[EEvaluationType.AutoQualified] += 1;
      }
    }
  }
  evaluationSummary.summary = x;
};

export const updateMultipleSelectEvaluationSummary = (evaluationSummary: TSelectEvaluationSummary) => {
  const x = {
    [EEvaluationType.Bonus]: 0,
    [EEvaluationType.Warning]: 0,
    [EEvaluationType.Disqualified]: 0,
    [EEvaluationType.Info]: 0,
  };

  for (const key in evaluationSummary.evaluation) {
    const value = evaluationSummary.evaluation[key];
    if (typeof value === 'object') {
      if (value.name === EEvaluationType.Info) {
        x[EEvaluationType.Info] += 1;
      } else if (value.name === EEvaluationType.Warning) {
        x[EEvaluationType.Warning] += 1;
      } else if (value.name === EEvaluationType.Bonus) {
        x[EEvaluationType.Bonus] += value.bonus_points ?? 0;
      } else if (value.name === EEvaluationType.Disqualified) {
        x[EEvaluationType.Disqualified] += 1;
      }
    }
  }
  evaluationSummary.summary = x;
};

export const updateFormSliderEvaluationSummary = (evaluationSummary: TSelectEvaluationSummary, nodeId: string) => {
  const x = {
    [EEvaluationType.Bonus]: 0,
    [EEvaluationType.Warning]: 0,
    [EEvaluationType.Disqualified]: 0,
    [EEvaluationType.Info]: 0,
    [EEvaluationType.Weighted]: 0,
  };

  for (const key in evaluationSummary.evaluation) {
    const evaluation = evaluationSummary.evaluation[key];

    if (Array.isArray(evaluation)) {
      evaluation.map((detail) => {
        if (detail.name === EEvaluationType.Info) {
          x[EEvaluationType.Info] += 1;
        }

        if (detail.name === EEvaluationType.Warning) {
          x[EEvaluationType.Warning] += 1;
        }

        if (detail.name === EEvaluationType.Bonus) {
          x[EEvaluationType.Bonus] = Math.max(x[EEvaluationType.Bonus], detail.bonus_points ?? 0);
        }

        if (detail.name === EEvaluationType.Disqualified) {
          x[EEvaluationType.Disqualified] += 1;
        }
      });
    } else {
      const y = zMatrixSliderEvaluationWeighted.safeParse(evaluation);
      if (y.success && typeof evaluation === 'object') {
        x[EEvaluationType.Weighted] += evaluation.weight ?? 0;
      } else {
        console.log('evaluation', evaluation);
        toast.error(`Side effects: ${nodeId}: Form evaluation is in unknown format, form: ${key}`);
      }
    }
  }
  evaluationSummary.summary = x;
};
